import styled from 'styled-components';
import { Card } from '@material-ui/core';

export const LoginBox = styled(Card)`
  margin-bottom: 32px;
`;

export const GameLogo = styled.img`
  float: right;
  height: 100px;
  margin-bottom: 10px;
`;

export const ReturnText = styled.p`
  margin-top: 12px;
`;

export const FieldContainer = styled.div`
  margin-bottom: 20px;
`;

export const ButtonContainer = styled.div`
  text-align: right;
`;
